import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';



import LandingVentas from './components/Landing';


function App() {
  
  return (
    <div className="App">
      <LandingVentas/>
    </div>
  );
}

export default App;
